<template>
  <v-card flat>
    <v-card-title class="title-font">
      HIGH SHINE POLISH<v-spacer />
      <div v-if="showErrors && !selection" class="error--text text-body-2">
        <v-icon color="error" class="mr-2">mdi-close-circle</v-icon>
        <span> Please make a selection </span>
      </div>
    </v-card-title>
    <v-card-subtitle class="pb-0">
      Would you like high shine polish on this bar? [+$100.00]
    </v-card-subtitle>
    <v-card-text class="py-0">
      <v-radio-group hide-details v-model="selection" class="mt-2">
        <v-radio
          v-for="(option, index) in options"
          :key="index"
          :value="option.value"
          :label="option.text"
        />
      </v-radio-group>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "BarHighShineAddon",

  props: ["value"],

  inject: ["form"],

  data() {
    return {
      options: [
        {
          text: "Yes",
          value: true
        },
        {
          text: "No",
          value: false
        }
      ],
      showErrors: false,
      valid: true
    }
  },

  computed: {
    selection: {
      get() {
        return this.value
      },
      set(value) {
        this.showErrors = false
        this.$emit("input", value)
      }
    }
  },

  methods: {
    validate() {
      if (this.selection === undefined) {
        this.showErrors = true
        return false
      }
      return true
    }
  },

  created() {
    this.form.register(this)
  }
}
</script>
